<template>
  <!--章-->
  <div id="examchapter">
    <h2 class="title">
      <a @click="back()" class="prev"></a>
      章节练习
    </h2>
    <div class="main" v-if="this.isChapter">
      <a @click="gotoTest('ExamSection', item.exam_id)" class="cc" v-for="(item, index) in chapterData.info" :key="index">
        <h4>{{item.name}}</h4>
        <p>开始答题</p>
      </a>
    </div>
    <div class="main" v-else>
      <!--
      <a href="" class="cc">
        <h4>学生观</h4>
        <p>开始答题</p>
      </a>
      <a href="" class="cc">
        <h4>教师观</h4>
        <p>开始答题</p>
      </a>
      <a href="" class="cc">
        <h4>教育观</h4>
        <p>开始答题</p>
      </a>
      <a href="" class="cc">
        <h4>教师职业道德</h4>
        <p>开始答题</p>
      </a>
      <a href="" class="cc">
        <h4>教师职业行为</h4>
        <p>开始答题</p>
      </a>
      <a href="" class="cc">
        <h4>历史素养</h4>
        <p>开始答题</p>
      </a>
      <a href="" class="cc">
        <h4>文化素养</h4>
        <p>开始答题</p>
      </a>
      <a href="" class="cc">
        <h4>科学素养</h4>
        <p>开始答题</p>
      </a>
      -->
      <a @click="gotoTest('ExamTest', item.exam_id)" class="cc" v-for="(item, index) in chapterData.info" :key="index">
        <h4>{{item.name}}</h4>
        <p>开始答题</p>
      </a>
    </div>
    <i-login @listenShow="showLogin" v-show="loginShow"></i-login>
  </div>
</template>

<script>
import iLogin from '../share/popup/login/iLogin'
export default {
  name: 'ExamChapter',
  data () {
    return {
      subjectId: this.$route.query.subject_id ? this.$route.query.subject_id : 1,
      page: 1,
      limit: 20,
      chapterData: {},
      isChapter: this.$route.query.is_chapter ? this.$route.query.is_chapter : 0,
      loginShow: 0
    }
  },
  components: {
    iLogin
  },
  mounted () {
    this.getExamChapter()
  },
  methods: {
    getExamChapter () {
      let data = {
        subject_id: this.subjectId,
        page: this.page,
        limit: this.limit
      }
      this.$axios({
        method: 'GET',
        url: '/api/app/v1/get_question_chapter_list',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          if (res.data.errcode === 200) {
            this.chapterData = res.data.data
          } else if (res.data.errcode === -1) {
            this.$store.dispatch('alterName', '')
            this.$store.dispatch('alterNickname', '')
            this.$store.dispatch('alterPortrait', '')
            this.$store.dispatch('alterSchool', '')
            this.$store.dispatch('alterToken', '')
            this.$store.dispatch('alterUid', '')
            this.$store.dispatch('alterVipname', '')
            this.$store.dispatch('alterViptime', '')
            // this.$router.push({name: 'PwdLogin'})
            this.loginShow = 1
          } else if (res.data.errcode === 400) {
            this.$store.dispatch('alterName', '')
            this.$store.dispatch('alterNickname', '')
            this.$store.dispatch('alterPortrait', '')
            this.$store.dispatch('alterSchool', '')
            this.$store.dispatch('alterToken', '')
            this.$store.dispatch('alterUid', '')
            this.$store.dispatch('alterVipname', '')
            this.$store.dispatch('alterViptime', '')
            // this.$router.push({name: 'PwdLogin'})
            this.loginShow = 1
          } else {
            console.log(res.data.message)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    back () {
      if (window.history.length <= 1) {
        this.$router.push({path: '/'})
      } else {
        this.$router.go(-1)
      }
    },
    showLogin (isShow) {
      this.loginShow = isShow
    },
    hideLogin () {
      this.loginShow = false
    },
    gotoTest (urlName, urlId) {
      if (this.$store.state.uid === '' || this.$store.state.uid === undefined) {
        this.loginShow = true
        return false
      }
      if (this.validataToken()) {
        this.$router.push({name: urlName, query: {exam_id: urlId}})
      }
    },
    // 验证是否需要登录弹窗
    validataToken () {
      let data = {
      }
      return this.$axios({
        method: 'GET',
        url: '/api/app/v1/overdue_user_token',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          console.log(res)
          if (res.data.errcode === 200) {
            return true
          } else if (res.data.errcode === 400) {
            this.$store.dispatch('alterName', '')
            this.$store.dispatch('alterNickname', '')
            this.$store.dispatch('alterPortrait', '')
            this.$store.dispatch('alterSchool', '')
            this.$store.dispatch('alterToken', '')
            this.$store.dispatch('alterUid', '')
            this.$store.dispatch('alterVipname', '')
            this.$store.dispatch('alterViptime', '')
            this.loginShow = true
          } else if (res.data.errcode === -1) {
            this.$store.dispatch('alterName', '')
            this.$store.dispatch('alterNickname', '')
            this.$store.dispatch('alterPortrait', '')
            this.$store.dispatch('alterSchool', '')
            this.$store.dispatch('alterToken', '')
            this.$store.dispatch('alterUid', '')
            this.$store.dispatch('alterVipname', '')
            this.$store.dispatch('alterViptime', '')
            this.loginShow = true
          } else console.log(res.data.message)
        })
        .catch(err => {
          console.log(err)
        })
    }
  }
}
</script>

<style scoped lang="stylus">
#examchapter
  @import "../../assets/stylus/examHead"
  .main
    display: flex
    justify-content: space-between
    align-items: center
    flex-wrap: wrap
    align-content: space-around
    padding: 0 .4rem
    -webkit-box-sizing: border-box
    -moz-box-sizing: border-box
    box-sizing: border-box
    a.cc
      display: block
      width: 3.12rem
      height: 2.6rem
      padding: .32rem
      border: .02rem solid #CFD1D4
      background: url(../../assets/img/examchapter_bg_pic1.png) no-repeat 2.1rem 1.58rem
      -webkit-background-size: .7rem .66rem
      background-size: .7rem .66rem
      margin: .16rem 0
      -webkit-box-sizing: border-box
      -moz-box-sizing: border-box
      box-sizing: border-box
      -webkit-border-radius: .2rem
      -moz-border-radius: .2rem
      border-radius: .2rem
      h4
        font-size: .3rem
        color: #050505
      p
        margin-top: .1rem
        font-size: .22rem
        color: #FF7052
      &:nth-of-type(8n+2)
        background: url(../../assets/img/examchapter_bg_pic2.png) no-repeat 1.96rem 1.62rem
        -webkit-background-size: .84rem .62rem
        background-size: .84rem .62rem
      &:nth-of-type(8n+3)
        background: url(../../assets/img/examchapter_bg_pic3.png) no-repeat 2rem 1.5rem
        -webkit-background-size: .8rem .74rem
        background-size: .8rem .74rem
      &:nth-of-type(8n+4)
        background: url(../../assets/img/examchapter_bg_pic4.png) no-repeat 2.06rem 1.46rem
        -webkit-background-size: .74rem .78rem
        background-size: .74rem .78rem
      &:nth-of-type(8n+5)
        background: url(../../assets/img/examchapter_bg_pic5.png) no-repeat 2.1rem 1.5rem
        -webkit-background-size: .70rem .74rem
        background-size: .70rem .74rem
      &:nth-of-type(8n+6)
        background: url(../../assets/img/examchapter_bg_pic6.png) no-repeat 2.04rem 1.58rem
        -webkit-background-size: .76rem .66rem
        background-size: .76rem .66rem
      &:nth-of-type(8n+7)
        background: url(../../assets/img/examchapter_bg_pic7.png) no-repeat 2.1rem 1.54rem
        -webkit-background-size: .7rem .7rem
        background-size: .7rem .7rem
      &:nth-of-type(8n)
        background: url(../../assets/img/examchapter_bg_pic8.png) no-repeat 1.98rem 1.42rem
        -webkit-background-size: .82rem .82rem
        background-size: .82rem .82rem
</style>



// WEBPACK FOOTER //
// src/components/exam/ExamChapter.vue